import conf from '../../../../../config/config';

/** 工事画像URL */
export const IMG_URL = conf.HELP_IMAGE_URL + 'DrSideKoziCost';

export const MANUALLY_ADDED = [
  {Code__c: true, Name: '手動追加'},
];

/**
 * 元位置建替有無(OnSiteRebuildUmu__c)のコード値。
 */
export const ON_SITE_REBUILD_UMU = {
  /** 無 */
  NONE: '0',

  /** 有(仮移設) */
  TEMPORARY_MOVE: '1',

  /** 有(元戻し) */
  RESTORE: '2',
};

/**
 * 算定ステータス(CalculationStatus__c)のコード値。
 */
export const CALCULATION_STATUS = {
  /** 算定済 */
  COMPLETED: '2',
};

/** 工事内容説明 */
export const KOJI_EXAMINATIONS = {
  A: {
    examination: ['高圧柱（３径間・段以上）', '開閉器'],
  },
  B: {
    examination: ['高圧柱（２径間・段以下）', '開閉器'],
  },
  C: {
    examination: ['高圧柱（３径間・段以上）', '変圧器'],
  },
  D: {
    examination: ['高圧柱（２径間・段以下）', '変圧器'],
  },
  E: {
    examination: ['高圧柱（３径間・段以上）', ' '],
  },
  F: {
    examination: ['高圧柱（２径間・段以下）'],
  },
  G: {
    examination: ['低圧柱'],
  },
  H: {
    examination: ['変圧器繰上げ'],
  },
  I: {
    examination: ['引込腕金繰上げ'],
  },
  J: {
    examination: ['遠制ケーブル繰上げ'],
  },
  K: {
    examination: ['支線張替・移替', '(架空支線、支線上部)'],
  },
  L: {
    examination: ['支線新設', ' '],
  },
  M: {
    examination: ['支線改修', '（普通支線⇒Ｙ支線）'],
  },
  N: {
    examination: ['引込線張替・移替', ' '],
  },
  O: {
    examination: ['メッセン張替・移替', '（柱間メッセン、片側メッセン）'],
  },
};

/**
 * モデル単価(ModelUnitPrice__c)のカテゴリ区分。
 * - overviewLabel: 「工事内容」表示文言の生成ロジック(改造工事費用算定SFDB.md参照)で使用するカテゴリ文言
 * - headerLabel/color: 工事内容入力ダイアログ(kojiEditDialog.js)のヘッダー表示文言/背景色
 */
export const MODEL_UNIT_PRICE_CATEGORIES = [
  {
    types: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
    overviewLabel: '電柱建替',
    headerLabel: '電柱建替',
    color: '#E2EFDA',
    kojiType: '1',
  },
  {
    types: ['H', 'I', 'J', 'K'],
    overviewLabel: '電力設備繰り上げ',
    headerLabel: '装柱変更（繰上げ）',
    color: '#DDEBF7',
    kojiType: '2',
  },
  {
    types: ['L', 'M'],
    overviewLabel: '支線工事',
    headerLabel: '支線関連',
    color: '#FFF2CC',
    kojiType: '3',
  },
  {
    types: ['N', 'O'],
    overviewLabel: '引込線工事',
    headerLabel: '引込線関連',
    color: '#FF6600',
    kojiType: '4',
  },
];

/**
 * 対象電柱の「工事内容」表示文言を生成する。
 *
 * 改造対象電柱明細(DrSideKoziTargetPoleDetails__r)に存在するモデル単価ごとに
 * カテゴリ文言を割り当て、重複を除いて「、」で連結する。
 *
 * 元位置建替有無の文言は付加しない(画面側では一覧に別項目として表示するため不要。
 * 帳票では付加した文言を出力するが、帳票はバックエンド側で生成するためフロント側では対応しない)。
 *
 * @param {object} pole 対象電柱(DrSideKoziTargetPole__c相当のオブジェクト)
 * @return {string} 工事内容表示文言
 */
export const getKoziOverview = (pole) => {
  const details = pole?.DrSideKoziTargetPoleDetails__r ?? [];
  const usedTypes = new Set(details.map((detail) => detail.ModelUnitPrice__c));

  const overviews = MODEL_UNIT_PRICE_CATEGORIES
      .filter((category) => category.types.some((type) => usedTypes.has(type)))
      .map((category) => category.overviewLabel);

  return overviews.join('、');
};
